export default "__VITE_ASSET__D4cgy47y__"